var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15.351 15.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-arrow-down",
    d: "M1.028 9.053l-.78-.78a.84.84 0 010-1.192L7.078.248a.84.84 0 011.192 0l6.833 6.833a.84.84 0 010 1.192l-.78.78a.845.845 0 01-1.206-.014L9.081 4.8v10.106a.842.842 0 01-.843.844H7.113a.842.842 0 01-.844-.844V4.8L2.234 9.036a.839.839 0 01-1.206.014z",
    fill: "currentColour"
  })));
}

export default SvgUpArrow;